import React from 'react'

export const CartDashboard = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6H20.7534C21.3931 6 21.8684 6.59242 21.7296 7.21693L20.522 12.6508C20.217 14.0234 18.9996 15 17.5935 15H9.54138C8.07486 15 6.82329 13.9398 6.5822 12.4932L5.4178 5.5068C5.17671 4.06024 3.92514 3 2.45862 3H2"
      stroke="#126554"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 22.25C9.24264 22.25 10.25 21.2426 10.25 20C10.25 18.7574 9.24264 17.75 8 17.75C6.75736 17.75 5.75 18.7574 5.75 20C5.75 21.2426 6.75736 22.25 8 22.25Z"
      stroke="#126554"
      strokeWidth="1.5"
    />
    <path
      d="M18 22.25C19.2426 22.25 20.25 21.2426 20.25 20C20.25 18.7574 19.2426 17.75 18 17.75C16.7574 17.75 15.75 18.7574 15.75 20C15.75 21.2426 16.7574 22.25 18 22.25Z"
      stroke="#126554"
      strokeWidth="1.5"
    />
  </svg>
)
